import React, { MouseEventHandler } from "react";
import ContainerComponent from "../../../../components/Container/ContainerComponent";
import ButtonComponent from "../../../../components/Button/ButtonComponent";
import TypographyComponent from "../../../../components/Typography/ThypographyComponent";
import BoxComponent from "../../../../components/Box/BoxComponent";
import ImageLogoComponent from "../../../../components/Image/ImageLogoComponent";
import LocationGrayIcon from "../../../../assets/icons/location_gray.png";
import ChevronRightIcon from "../../../../assets/icons/chevron_right.png";

interface InfosEntregaProps {
    onClickEntrega: MouseEventHandler<HTMLButtonElement>;
}

const InfosEntregaComponent = (props: InfosEntregaProps) => {
    return <ContainerComponent
        component="section"
        sx={{
            display: 'flex',
            flexDirection: 'column',
            mt: 3,
        }}
    >
        <ButtonComponent
            id="taxa_tempo_entrega"
            variant="outlined"
            onClick={props.onClickEntrega}
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                transform: 'rotate(0deg)',
                opacity: 1,
                borderRadius: '14.4px',    // Borda arredondada
                border: '1px solid',       // 'stroke weight/1' mapeado para 1px
                borderColor: 'divider',
                padding: '16.6px',
                boxSizing: 'border-box',
            }}
        >
            <BoxComponent
                component="div"
                sx={{
                    display: "flex",
                    width: "98%"
                }}
            >
                <TypographyComponent
                    variant="button"
                    color="text.secondary"
                    sx={{
                        display: 'flex',
                        alignItems: "center",
                        alignContent: "center",
                        justifyContent: 'center',
                        gap: 1,
                        fontFamily: '"Font 7", "Roboto", "Helvetica", "Arial", sans-serif',
                        fontWeight: 600,       // Semi Bold
                        fontSize: '1rem',      // 16px / 16px = 1rem
                        lineHeight: 1.5,       // 24px / 16px
                        letterSpacing: '0em',
                        textAlign: 'center',
                        textTransform: 'none',

                    }}
                    fontWeight="bold"
                >
                    <ImageLogoComponent
                        sx={{
                            width: 18,
                            height: 18,
                            margin: "auto"
                        }}
                        src={LocationGrayIcon}
                        alt="location_frete_indicator_icon"
                    />
                    Calcular taxa e tempo de entrega
                </TypographyComponent>
            </BoxComponent>

            <ImageLogoComponent
                sx={{
                    width: 20,
                    height: 20,
                    margin: "auto"
                }}
                src={ChevronRightIcon}
                alt="indicador_taxa_tempo_entrega"
            />
        </ButtonComponent>
    </ContainerComponent>
}

export default InfosEntregaComponent;